import { Center, CloseButton, Flex, Text } from '@mantine/core';

type TimelineComparisonSummaryPropsType = {
  clearAriaLabel: string;
  formattedDateRange: string;
  formattedIncrease: string;
  onClear: () => void;
};

export const TimelineComparisonSummary: React.FC<
  TimelineComparisonSummaryPropsType
> = ({ clearAriaLabel, formattedDateRange, formattedIncrease, onClear }) => {
  return (
    <Flex justify="flex-end" gap="xs" align="center">
      <Text size="xs" c="dimmed">
        {formattedDateRange}
      </Text>
      <Text size="xs" fw={600}>
        {formattedIncrease}
      </Text>
      <Center>
        <CloseButton
          size="xs"
          onClick={onClear}
          aria-label={clearAriaLabel}
        />
      </Center>
    </Flex>
  );
};
